import React, { createContext, useContext, useState, useCallback } from 'react';
import { handleApiError } from '../utils/apiErrorHandler';

const ApiContext = createContext(null);

export function ApiProvider({ children }) {
  const [globalError, setGlobalError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleRequest = useCallback(async (apiCall, options = {}) => {
    const { showLoading = true, handleError = true } = options;

    try {
      if (showLoading) setIsLoading(true);
      const response = await apiCall();
      return response;
    } catch (error) {
      if (handleError) {
        const apiError = handleApiError(error);
        setGlobalError(apiError);
        throw apiError;
      }
      throw error;
    } finally {
      if (showLoading) setIsLoading(false);
    }
  }, []);

  const clearError = useCallback(() => {
    setGlobalError(null);
  }, []);

  return (
    <ApiContext.Provider value={{ handleRequest, globalError, clearError, isLoading }}>
      {children}
    </ApiContext.Provider>
  );
}

export const useApi = () => {
  const context = useContext(ApiContext);
  if (!context) {
    throw new Error('useApi must be used within an ApiProvider');
  }
  return context;
}; 